import React, { memo } from "react";
import PropTypes from "prop-types";

import { Text } from "./text";
import { TextArea } from "./textarea";
import { Slider } from "./slider";
import { SingleUserSelect } from "./singleuser";
import { MultiUserSelect } from "./multiuser";
import { Rating } from "./rating";
import { Currency } from "./currency";
import { SingleSelect } from "./singleselect";
import { MultiSelect } from "./multiselect";
import { Date } from "./date";
import { DateTime } from "./datetime";
import { Boolean } from "./boolean";
import { Checklist } from "./checklist";
import { Attachment } from "./attachment";
import { Image } from "./image";
import { Signature } from "./signature";
import { Number } from "./number";
import { Lookup } from "./lookup";
import { Empty } from "./empty";
import { RemoteLookup } from "./remotelookup";

// eslint-disable-next-line no-unused-vars
import styles from "./style.css";

export function EditorComponent(props) {
  const { column, isVisible } = props;

  if (isVisible === false) {
    return <Empty {...props} />;
  }

  if (column.editor) {
    return <column.editor {...props} />;
  }

  switch (
    (column.widgetType && column.widgetType.toLowerCase()) ||
    column.type.toLowerCase()
  ) {
    case "text":
      return <Text {...props} />;
    case "slider":
      return <Slider {...props} />;
    case "user":
      return <SingleUserSelect {...props} />;
    case "userandgroup":
      return <SingleUserSelect {...props} />;
    case "multiuser":
      return <MultiUserSelect {...props} />;
    case "starrating":
      return <Rating {...props} />;
    case "currency":
      return <Currency {...props} />;
    case "select":
      return <SingleSelect {...props} />;
    case "multiselect":
      return <MultiSelect {...props} />;
    case "checkbox":
      return <MultiSelect {...props} isCheckbox={true} />;
    case "date":
      return <Date {...props} />;
    case "datetime":
      return <DateTime {...props} />;
    case "boolean":
      return <Boolean {...props} />;
    case "textarea":
      return <TextArea {...props} />;
    case "checklist":
      return <Checklist {...props} />;
    case "attachment":
      return <Attachment {...props} />;
    case "image":
      return <Image {...props} />;
    case "signature":
      return <Signature {...props} />;
    case "number":
      return <Number {...props} />;
    case "reference":
      return <Lookup {...props} />;
    case "remotelookup-json-auto":
    case "remotelookup-text-auto":
    case "remotelookup-xml-auto":
    case "remotelookup-json-manual":
    case "remotelookup-text-manual":
    case "remotelookup-xml-manual":
      return <RemoteLookup {...props} />;
    default:
      return <Text {...props} />;
  }
}

EditorComponent.propTypes = {
  column: PropTypes.any,
  isVisible: PropTypes.bool
};

export const Editor = memo(EditorComponent);
